export default __webpack_public_path__ + "static/featuresListItem6-580422cd52742ab498c3fbd73960bf6e.svg";